import React from 'react';
import { gql, useQuery } from '@apollo/client';
import { useI18n } from '~Hooks';
import { VariationNameQuery, VariationNameQueryVariables } from './__queries__/VariationNameQuery';
import styled from '@emotion/styled';

export const VARIATION_NAME_QUERY = gql`
  query VariationNameQuery($id: ID!) {
    variation: Variation(id: $id) {
      id
      highlighted
      name
      nameLang {
        id
        se
        en
        es
        no
      }
    }
  }
`;

const Wrapper = styled.span<{ deleted?: boolean; markGreen?: boolean }>`
  color: ${(props) => {
    if (props.deleted) return 'var(--colorUIRed)';
    if (props.markGreen) return 'var(--colorUIGreen)';
    return 'var(--colorBlueGray1200)';
  }};
  font-weight: ${(props) => (props.deleted || props.markGreen ? 600 : 400)};
`;

interface Props {
  id: string;
  deleted?: boolean;
  markGreen?: boolean;
}

const VariationName: React.FC<Props> = ({ id, deleted, markGreen }) => {
  const { i18n } = useI18n();
  const { data } = useQuery<VariationNameQuery, VariationNameQueryVariables>(
    VARIATION_NAME_QUERY,
    {
      variables: {
        id,
      },
      fetchPolicy: 'cache-first',
    },
  );

  return (
    <Wrapper deleted={deleted || data?.variation?.highlighted} markGreen={markGreen}>
      {data?.variation
        ? i18n(data.variation.nameLang).length > 0
          ? i18n(data.variation.nameLang)
          : data.variation.name
        : id}
    </Wrapper>
  );
};

export default React.memo(VariationName);
